import React from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CustomDialog from "../shared/CustomDialog";
import CloseIcon from "../img/svg/close_blue_new_design.svg";

const HealthDeclarationDialog = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <CustomDialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Box>
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "3px",
            textAlign: "center",
          }}
          id="customized-dialog-title"
        >
          <img src={CloseIcon} alt="close" onClick={onClose} />
          <Typography
            className="open-sans-hebrew"
            gutterBottom
            sx={{
              fontSize: "24px",
              m: 0,
              color: "var(--darkblue)",
              textAlign: "center",
              fontWeight: 700,
              fontFamily: `var(--font-family) !important`,
            }}
          >
            {t("REGISTRATION_QUESTIONS.MEDICAL_APPROVAL_REQUIRED")}
          </Typography>
        </DialogTitle>
      </Box>

      <DialogContent>
        <Typography
          className="test"
          sx={{
            fontFamily: `var(--font-family) !important`,
            fontSize: "16px",
            m: 0,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            gap: "0px",
            alignItems: "flex-end",
            mb: "46px",
            mx: "14px",
          }}
        >
          <p
            style={{
              textAlign: "right",
              color: "#565656",
              display: "flex",
              flexDirection: "column-reverse",
              gap: "0px",
            }}
          >
            <p style={{ letterSpacing: "-1px", marginLeft: "5px" }}>
              {t("REGISTRATION_QUESTIONS.MEDICAL_APPROVAL_MESSAGE_1")}
            </p>
          </p>
          <p
            style={{
              color: "#565656",
              textAlign: "right",
            }}
          >
            <span>{t("REGISTRATION_QUESTIONS.MEDICAL_APPROVAL_MESSAGE_2")}</span>
          </p>
          <p
            style={{
              color: "#565656",
              textAlign: "right",
            }}
          >
            <span>{t("REGISTRATION_QUESTIONS.MEDICAL_APPROVAL_MESSAGE_3")}</span>
          </p>
          <p
            style={{
              color: "#565656",
            }}
          >
            <span>{t("REGISTRATION_QUESTIONS.MEDICAL_APPROVAL_MESSAGE_4")}</span>
          </p>
          <p
            style={{
              color: "#565656",
            }}
          >
            <a href={`tel:033730300`} style={{ color: "#139DEB", textDecoration: "underline" }}>
              03-3730300
            </a>
          </p>
          <p
            style={{
              color: "#565656",
              textAlign: "right",
            }}
          >
            <span style={{ textAlign: "right" }}>{t("REGISTRATION_QUESTIONS.MEDICAL_APPROVAL_MESSAGE_5")}</span>
          </p>
          <p
            style={{
              color: "#565656",
            }}
          >
            <span>{t("REGISTRATION_QUESTIONS.MEDICAL_APPROVAL_MESSAGE_6")}</span>
          </p>
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 0, m: 0 }}>
        <Button
          onClick={onClose}
          variant="contained"
          className="phone-dialog-btn phone-dialog-darkblue-btn w-100-percents"
          sx={{ py: "16px", whiteSpace: "nowrap" }}
        >
          {t("CLOSE")}
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default HealthDeclarationDialog;
